module.exports = __webpack_public_path__ + "img/cashback_960.5efb029c.png";